module.exports = __webpack_public_path__ + "static/2-be55d170c4ffc2898312a7a8f64dcd9d.png";